import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from '@/app/providers/AppProviders';
import { App } from '@/App';
import { env } from '@/lib/env';
import './index.css';

// Validate env once at startup (fail fast on a misconfigured deploy) and expose it for debugging.
document.documentElement.dataset.env = env.VITE_ENV;

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
